export default __webpack_public_path__ + "static/media/thumbnail.4a88c70b.webp";